module.exports = __webpack_public_path__ + "static/media/me-books-logo.13e192fc.png";